module.exports = __webpack_public_path__ + "static/media/BreathingTechniquesENG.b1ab798d.vtt";